module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/note-20fafd88.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/note.svg
// module id = ./app/web/src/assets/note.svg
// module chunks = 0